import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const READ_ONLY_MESSAGE = "Your account is read only. Subscribe to keep working.";

// Mirrors the server's read-only state (see trial_gate in server.py). The
// server is what actually enforces it; this only saves a pointless round trip
// and gives the page the same sentence the server would have returned.
let readOnlyMode = false;
const READ_ONLY_ALLOWED = ["/auth/logout", "/auth/session", "/auth/demo-login"];

export function setReadOnlyMode(value) {
  readOnlyMode = !!value;
}

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const writes = !["get", "head", "options"].includes(method);
  const url = config.url || "";
  if (readOnlyMode && writes && !READ_ONLY_ALLOWED.some((p) => url.startsWith(p))) {
    const err = new Error(READ_ONLY_MESSAGE);
    err.response = { status: 402, data: { detail: READ_ONLY_MESSAGE, read_only: true } };
    return Promise.reject(err);
  }
  return config;
});

// Surface the backend's real reason instead of a generic "something failed".
export function apiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length) return detail[0]?.msg || fallback;
  if (err?.message && !/^Request failed/.test(err.message)) return err.message;
  return fallback;
}
